<script setup>
import { ref } from 'vue';
import SelectorEstructura from '@/components/SelectorEstructura.vue';

const emits = defineEmits(['seleccionado', 'cancelado']);

const cursoSeleccionado = ref(null);

</script>
<template>
  <div class="seleccion-curso">
    <label for="" class="input-label">
      {{ $t('seleccion_curso') }}
    </label>
    <SelectorEstructura
      ref="selectorEstructura"
      :tipos-seleccionables="['curso']"
      :ocultar-limpiar="true"
      :solo-cursos-lomloe="true"
      @seleccionada="cursoSeleccionado = $event"
    />
    <div class="form-actions m-t">
      <button
        class="btn btn-default"
        type="button"
        @click="emits('cancelado')"
        v-text="$t('Cancelar')"
      />
      <button
        type="button"
        class="btn btn-cifra"
        :disabled="!cursoSeleccionado"
        @click="emits('seleccionado', cursoSeleccionado)"
      >
        <i class="fa fa-plus"></i> {{ $t('Anadir') }}
      </button>
    </div>
  </div>
</template>
